export default __webpack_public_path__ + "static/14-ef9f40e5fba91b81618bd8229fee6762.png";